import { getFeaturePanelDefinition } from "../feature-panel-registry.ts";
import type { RuntimeFeatureModule } from "../runtime-feature-registry.ts";
import {
  applyTextEffectValue,
  resetTextEffectValue,
} from "../shared/page-text-effects.ts";
import {
  createRangeControl,
  formatNumber,
  normalizeSteppedValue,
  parseNumericConfig,
} from "../shared/feature-value.ts";

const variable = "--migrosone-a11y-text-scale";
const attribute = "data-migrosone-a11y-text-size";
const fallback = {
  defaultValue: 100,
  min: 90,
  max: 150,
  step: 10,
};

function getConfig(config: unknown) {
  return parseNumericConfig({
    config,
    defaultKeys: ["scale"],
    fallback,
  });
}

const definition = getFeaturePanelDefinition("text-size");

if (!definition) {
  throw new Error("Missing text-size feature definition");
}

export const textSizeFeatureModule: RuntimeFeatureModule = {
  key: "text-size",
  definition,
  isSupported({ document }) {
    return Boolean(document.head && document.documentElement);
  },
  renderControl({ config, document, onPreferenceChange, preference }) {
    const numericConfig = getConfig(config);
    return createRangeControl({
      config: numericConfig,
      document,
      label: "Yazı boyutu",
      onPreferenceChange,
      preference,
      suffix: "%",
    });
  },
  apply({ config, document, preference }) {
    const numericConfig = getConfig(config);
    const value = normalizeSteppedValue(preference, numericConfig);
    applyTextEffectValue({
      attribute,
      document,
      value: `${formatNumber(value)}%`,
      variable,
    });
  },
  reset({ config, document }) {
    resetTextEffectValue({ attribute, document, variable });
    const numericConfig = getConfig(config);
    applyTextEffectValue({
      attribute,
      document,
      value: `${formatNumber(numericConfig.defaultValue)}%`,
      variable,
    });
  },
};
